<template>
  <div class="page-wrap" :class="{ night, 'has-keypad': keypadOpen }">
    <header class="topbar">
      <button class="back" type="button" aria-label="返回" @click="goBack">
        <svg viewBox="0 0 24 24">
          <path d="M15.2 5 8.2 12l7 7" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <div class="chase-tabs">
        <button type="button" :class="{ on: tab === 'normal' }" @click="switchTab('normal')">普通追号</button>
        <button type="button" :class="{ on: tab === 'double' }" @click="switchTab('double')">翻倍追号</button>
        <button type="button" :class="{ on: tab === 'profit' }" @click="switchTab('profit')">利润率</button>
      </div>
      <button class="scan" type="button" aria-label="截图">
        <svg viewBox="0 0 24 24">
          <path d="M4 9V5h4M20 9V5h-4M4 15v4h4M20 15v4h-4" fill="none" stroke="#ffd1b8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </header>

    <section class="play-info">
      <span class="game-name">体彩P3P5</span>
      <span class="count-txt">&nbsp;距 {{ startIssue }} 截止&nbsp;</span>
      <span class="clock">06:35:00</span>
    </section>

    <div class="chase-top">
      <div class="chase-input-container">
        <div class="chase-input start-input">
          <div class="chase-left">起始</div>
          <div class="issue-arrow"><span>{{ startIssue }}(当期)</span></div>
        </div>
        <button class="add-chase-btn" type="button" @click="generateChase">生成追号</button>
      </div>

      <div class="chase-input-container">
        <div class="chase-input">
          <div class="chase-left">期数</div>
          <div class="chase-right">
            <button class="minus" type="button" @click="stepField('periods', -1)"><img :src="iconMinus" alt="" /></button>
            <div class="input-block">
              <button class="number-input" :class="{ on: keypadOpen && activeField === 'periods' }" type="button" @click="openKeypad('periods')">{{ displayVal('periods') }}</button>
            </div>
            <button class="plus" type="button" @click="stepField('periods', 1)"><img :src="iconPlus" alt="" /></button>
          </div>
          <div class="unit">期</div>
        </div>
        <div class="chase-input end">
          <div class="chase-left">倍数</div>
          <div class="chase-right">
            <button class="minus" type="button" @click="stepField('multiple', -1)"><img :src="iconMinus" alt="" /></button>
            <div class="input-block">
              <button class="number-input" :class="{ on: keypadOpen && activeField === 'multiple' }" type="button" @click="openKeypad('multiple')">{{ displayVal('multiple') }}</button>
            </div>
            <button class="plus" type="button" @click="stepField('multiple', 1)"><img :src="iconPlus" alt="" /></button>
          </div>
        </div>
      </div>

      <div v-if="tab === 'double'" class="chase-input-container">
        <div class="chase-input">
          <div class="chase-left">每隔</div>
          <div class="chase-right">
            <button class="minus" type="button" @click="stepField('interval', -1)"><img :src="iconMinus" alt="" /></button>
            <div class="input-block">
              <button class="number-input" :class="{ on: keypadOpen && activeField === 'interval' }" type="button" @click="openKeypad('interval')">{{ displayVal('interval') }}</button>
            </div>
            <button class="plus" type="button" @click="stepField('interval', 1)"><img :src="iconPlus" alt="" /></button>
          </div>
          <div class="unit">期</div>
        </div>
        <div class="chase-input end">
          <div class="chase-left">倍数 x</div>
          <div class="chase-right">
            <button class="minus" type="button" @click="stepField('doubleFactor', -1)"><img :src="iconMinus" alt="" /></button>
            <div class="input-block">
              <button class="number-input" :class="{ on: keypadOpen && activeField === 'doubleFactor' }" type="button" @click="openKeypad('doubleFactor')">{{ displayVal('doubleFactor') }}</button>
            </div>
            <button class="plus" type="button" @click="stepField('doubleFactor', 1)"><img :src="iconPlus" alt="" /></button>
          </div>
        </div>
      </div>

      <div v-if="tab === 'profit'" class="chase-input-container">
        <div class="chase-input">
          <div class="chase-left">最低利润率</div>
          <div class="chase-right profit">
            <button class="minus" type="button" @click="stepField('lowestYield', -1)"><img :src="iconMinus" alt="" /></button>
            <div class="input-block wide">
              <button class="number-input" :class="{ on: keypadOpen && activeField === 'lowestYield' }" type="button" @click="openKeypad('lowestYield')">{{ displayVal('lowestYield') }}</button>
            </div>
            <button class="plus" type="button" @click="stepField('lowestYield', 1)"><img :src="iconPlus" alt="" /></button>
          </div>
          <div class="unit">%</div>
        </div>
      </div>
    </div>

    <div class="table-head">
      <span>选择</span>
      <span>追号期号</span>
      <span>倍数</span>
      <span>当前投入(U)</span>
    </div>

    <div class="table-body">
      <template v-for="item in chaseItems" :key="item.id">
        <article class="chase-row" :class="{ 'profit-main-row': tab === 'profit' }">
          <button class="pick" type="button" :class="{ on: item.selected }" @click="item.selected = !item.selected">
            <svg v-if="item.selected" viewBox="0 0 16 16"><path d="M4 8.5l2.5 2.5L12 5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <span class="issue">{{ item.issue }}</span>
          <div class="mult-cell">
            <button
              class="mult-box"
              type="button"
              :class="{ on: keypadOpen && activeField === itemKey(item) }"
              @click="openKeypad(itemKey(item), item.multiple)"
            >{{ displayItemMultiple(item) }}</button>
            <span class="mult-unit">倍</span>
          </div>
          <span class="amount">{{ displayItemAmount(item) }} U</span>
        </article>
        <article v-if="tab === 'profit'" class="profit-row">
          <div class="profit-col">
            <div class="profit-label">累计投入(U):</div>
            <div class="profit-val">{{ formatAmount4(cumulativeAmount(item)) }}U</div>
          </div>
          <div class="profit-col">
            <div class="profit-label">当期奖金:</div>
            <div class="profit-val">{{ formatAmount4(currentBonus(item)) }}U</div>
          </div>
          <div class="profit-col">
            <div class="profit-label">利润率:</div>
            <div class="profit-val">{{ formatRate2(profitRate(item)) }}%</div>
          </div>
        </article>
      </template>
    </div>

    <footer class="ftr">
      <div v-if="keypadOpen" class="chase-keypad">
        <button class="key" type="button" @click="pressKey('1')">1</button>
        <button class="key" type="button" @click="pressKey('2')">2</button>
        <button class="key" type="button" @click="pressKey('3')">3</button>
        <button class="side" type="button" @click="hideKeypad">
          <img class="vk-ico" :src="iconVkHide" alt="" />
          隐藏
        </button>
        <button class="key" type="button" @click="pressKey('4')">4</button>
        <button class="key" type="button" @click="pressKey('5')">5</button>
        <button class="key" type="button" @click="pressKey('6')">6</button>
        <button class="side" type="button" @click="pressKey('clear')">
          <img class="vk-ico" :src="iconVkClear" alt="" />
          清零
        </button>
        <button class="key" type="button" @click="pressKey('7')">7</button>
        <button class="key" type="button" @click="pressKey('8')">8</button>
        <button class="key" type="button" @click="pressKey('9')">9</button>
        <button class="side ok" type="button" @click="confirmKeypad">
          <img class="vk-ico ok" :src="iconVkOk" alt="" />
          确认
        </button>
        <button class="key" type="button" @click="pressKey('.')">.</button>
        <button class="key" type="button" @click="pressKey('0')">0</button>
        <button class="key vk-back" type="button" aria-label="退格" @click="pressKey('del')">
          <img class="vk-ico" :src="iconVkBack" alt="" />
          <span>回退</span>
        </button>
      </div>

      <div class="sum-row">
        <div class="sum-left">你追号{{ selectedCount }}期&nbsp; 共<span class="hl">{{ totalAmount }}</span></div>
        <div class="sum-right">
          余额<span class="hl">{{ hideBalance ? '***' : balance }}</span>
          <button type="button" aria-label="刷新" @click="refreshBalance">
            <img :src="iconRefresh" alt="" />
          </button>
          <button type="button" :aria-label="hideBalance ? '显示余额' : '隐藏余额'" @click="hideBalance = !hideBalance">
            <img :src="hideBalance ? iconEyeOff : iconEye" alt="" />
          </button>
        </div>
      </div>
      <div class="foot-row">
        <label class="stop-win">
          <span class="check-circle on">
            <svg viewBox="0 0 16 16"><path d="M4 8.5l2.5 2.5L12 5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          <span>中奖停止</span>
        </label>
        <button class="bet-btn" type="button" :disabled="!canBet" @click="openConfirm">立 即 投 注</button>
      </div>
    </footer>

    <teleport to="body">
      <div v-if="showConfirm" class="confirm-mask" :class="{ night }" @click.self="showConfirm = false">
        <div class="confirm-sheet">
          <h3 class="cs-title">投注信息确认</h3>
          <p class="cs-warn">【单挑模式】说明：投注的中奖概率低于或等于1%的均为单挑模式。</p>
          <p class="cs-warn-sub">(单挑每期订单奖金上限50000.00 U，超出的奖金系统将予以扣除)</p>
          <div class="cs-info">
            <p>彩种：体彩P3P5</p>
            <p>期号：第{{ startIssue }}期</p>
            <p>是否追号：是</p>
            <p>追号期数：{{ selectedCount }}</p>
          </div>
          <div class="cs-summary">
            <span>注数：{{ totalStakeCount }}</span>
            <span>总计：{{ totalAmount }}</span>
          </div>
          <p class="cs-notice">订单确认后不可取消。</p>
          <div class="cs-actions">
            <button class="cs-cancel" type="button" @click="showConfirm = false">取消</button>
            <button class="cs-ok" type="button" @click="doSubmit">确认</button>
          </div>
        </div>
      </div>
    </teleport>

    <BetFeedbackModals
      :balance-tip-sheet="balanceTipSheet"
      :balance-tip-countdown="balanceTipCountdown"
      :close-balance-tip="closeBalanceTip"
      :bet-success-sheet="betSuccessSheet"
      :bet-success-countdown="betSuccessCountdown"
      :close-bet-success-tip="closeBetSuccessTip"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { lgwApi } from '@/api/lgw'
import BetFeedbackModals from '@/components/BetFeedbackModals.vue'
import { useBetFeedback } from '@/composables/useBetFeedback'
import { useTheme } from '@/composables/useTheme'
import iconEye from '@/assets/lobby/ui/bet-eye.svg'
import iconEyeOff from '@/assets/lobby/ui/bet-eye-off.svg'
import iconRefresh from '@/assets/lobby/ui/bet-refresh.svg'
import iconMinus from '@/assets/lobby/ui/chase-minus.svg'
import iconPlus from '@/assets/lobby/ui/chase-plus.svg'
import iconVkHide from '@/assets/lobby/ui/vk-hide.svg'
import iconVkClear from '@/assets/lobby/ui/vk-clear.svg'
import iconVkBack from '@/assets/lobby/ui/vk-back.svg'
import iconVkOk from '@/assets/lobby/ui/vk-ok.svg'

const router = useRouter()
const { night } = useTheme()
const startIssue = '2026220'
const unitStake = 4

const {
  balanceTipSheet,
  balanceTipCountdown,
  closeBalanceTip,
  betSuccessSheet,
  betSuccessCountdown,
  closeBetSuccessTip,
  openBalanceTip,
  openBetSuccessTip
} = useBetFeedback()

const balance = ref(0)
const hideBalance = ref(false)
const tab = ref('normal')
const periods = ref(1)
const multiple = ref(1)
const interval = ref(1)
const doubleFactor = ref(2)
const lowestYield = ref(50)
const chaseItems = ref([])
const keypadOpen = ref(false)
const activeField = ref('')
const draft = ref('')
const replaceNext = ref(true)
const showConfirm = ref(false)
const submitting = ref(false)

const refreshBalance = async () => {
  try {
    const res = await lgwApi.account()
    const data = res?.data || res
    balance.value = Number(data?.availBalance ?? data?.balance ?? 0)
  } catch {
    balance.value = 0
  }
}

const selectedCount = computed(() => chaseItems.value.filter((it) => it.selected).length)
const totalStakeCount = computed(() => chaseItems.value.filter((it) => it.selected).reduce((s, it) => s + it.multiple, 0))
const totalAmount = computed(() => chaseItems.value.filter((it) => it.selected).reduce((s, it) => s + displayItemAmount(it), 0))
const canBet = computed(() => selectedCount.value > 0)

const itemKey = (item) => `item:${item.id}`
const baseBonusPerMultiple = 1000

const parseDraft = (min = 1) => {
  const n = parseInt(draft.value, 10)
  return !n || n < min ? min : Math.min(9999, n)
}

const displayItemMultiple = (item) => {
  if (keypadOpen.value && activeField.value === itemKey(item)) return draft.value
  return item.multiple
}

const displayItemAmount = (item) => {
  const mult = keypadOpen.value && activeField.value === itemKey(item)
    ? (parseInt(draft.value, 10) || 0)
    : item.multiple
  return unitStake * mult
}

const cumulativeAmount = (item) => {
  const idx = chaseItems.value.findIndex((it) => it.id === item.id)
  if (idx < 0) return displayItemAmount(item)
  return chaseItems.value
    .slice(0, idx + 1)
    .reduce((sum, it) => sum + displayItemAmount(it), 0)
}

const currentBonus = (item) => displayItemMultiple(item) * baseBonusPerMultiple

const profitRate = (item) => {
  const invested = cumulativeAmount(item)
  if (!invested) return 0
  return ((currentBonus(item) - invested) / invested) * 100
}

const formatAmount4 = (n) => Number(n || 0).toFixed(2)
const formatRate2 = (n) => Number(n || 0).toFixed(2)

const goBack = () => {
  if (window.history.length > 1) router.back()
  else router.replace('/cart')
}

const switchTab = (next) => {
  if (tab.value === next) return
  tab.value = next
  chaseItems.value = []
  hideKeypad()
}

const calcMultiple = (index) => {
  if (tab.value !== 'double') return multiple.value
  const steps = Math.floor(index / interval.value)
  return multiple.value * (doubleFactor.value ** steps)
}

const generateChase = () => {
  hideKeypad()
  const start = Number(startIssue)
  const count = Math.max(1, periods.value)
  chaseItems.value = Array.from({ length: count }, (_, i) => {
    const mult = calcMultiple(i)
    return {
      id: `${tab.value}-${i}-${Date.now()}`,
      issue: String(start + i),
      multiple: mult,
      amount: unitStake * mult,
      selected: true,
    }
  })
}

const fieldValue = (field) => {
  if (field === 'periods') return periods.value
  if (field === 'multiple') return multiple.value
  if (field === 'interval') return interval.value
  if (field === 'lowestYield') return lowestYield.value
  return doubleFactor.value
}

const setFieldValue = (field, value) => {
  const min = field === 'doubleFactor' ? 2 : 1
  const next = Math.max(min, Math.min(9999, value))
  if (field === 'periods') periods.value = next
  else if (field === 'multiple') multiple.value = next
  else if (field === 'interval') interval.value = next
  else if (field === 'lowestYield') lowestYield.value = next
  else doubleFactor.value = next
}

const displayVal = (field) => {
  if (keypadOpen.value && activeField.value === field) return draft.value
  return fieldValue(field)
}

const stepField = (field, delta) => {
  setFieldValue(field, fieldValue(field) + delta)
}

const applyDraft = () => {
  const field = activeField.value
  if (!field) return
  if (field.startsWith('item:')) {
    const id = field.slice(5)
    const item = chaseItems.value.find((it) => it.id === id)
    if (!item) return
    const next = parseDraft(1)
    item.multiple = next
    item.amount = unitStake * next
    return
  }
  const min = field === 'doubleFactor' ? 2 : 1
  setFieldValue(field, parseDraft(min))
}

const openKeypad = (field, current) => {
  activeField.value = field
  draft.value = String(current ?? fieldValue(field))
  replaceNext.value = true
  keypadOpen.value = true
}

const hideKeypad = () => {
  applyDraft()
  keypadOpen.value = false
  activeField.value = ''
  draft.value = ''
  replaceNext.value = true
}

const confirmKeypad = () => {
  hideKeypad()
}

const pressKey = (key) => {
  if (key === 'clear') {
    draft.value = ''
    replaceNext.value = true
    return
  }
  if (key === 'del') {
    draft.value = draft.value.slice(0, -1)
    replaceNext.value = !draft.value
    return
  }
  if (key === '.') return
  const isPeriods = activeField.value === 'periods'
  if (isPeriods) {
    draft.value = key === '0' ? '1' : key
    return
  }
  if (replaceNext.value) {
    draft.value = key === '0' ? '' : key
    replaceNext.value = false
    return
  }
  if (draft.value.length >= 4) return
  draft.value += key
}

const openConfirm = () => {
  if (!canBet.value || submitting.value) return
  showConfirm.value = true
}

const doSubmit = async () => {
  if (!canBet.value || submitting.value) return
  showConfirm.value = false
  await refreshBalance()
  if (balance.value < totalAmount.value) {
    openBalanceTip()
    return
  }
  submitting.value = true
  try {
    // 追号下单接口未独立接入时：余额校验通过后按投注页同款反馈「购买成功」，并同步余额
    openBetSuccessTip()
    await refreshBalance()
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  refreshBalance()
})
</script>

<style scoped>
.page-wrap {
  box-sizing: border-box;
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: calc(86px + env(safe-area-inset-bottom));
  background: #f5f5f5;
  color: #333;
  font-family: 'PingFang SC', 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
}

.page-wrap.has-keypad {
  padding-bottom: calc(316px + env(safe-area-inset-bottom));
}

.topbar {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(44px + env(safe-area-inset-top, 0px));
  min-height: calc(44px + env(safe-area-inset-top, 0px));
  max-height: calc(44px + env(safe-area-inset-top, 0px));
  padding: env(safe-area-inset-top, 0px) 0 0;
  overflow: hidden;
  background: #f42c4c;
  flex-shrink: 0;
}

.back, .scan {
  position: absolute;
  top: env(safe-area-inset-top, 0px);
  width: 44px;
  height: 44px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.back { left: 4px; }
.scan { right: 4px; }
.back svg, .scan svg { width: 22px; height: 22px; display: block; margin: 0 auto; }

.chase-tabs {
  box-sizing: border-box;
  display: inline-flex;
  align-items: stretch;
  align-self: flex-end;
  margin-bottom: 8px;
  height: 28px;
  max-height: 28px;
  border: 1px solid rgba(255,255,255,0.7);
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}
.chase-tabs button {
  box-sizing: border-box;
  height: 28px;
  max-height: 28px;
  padding: 0 12px;
  border: 0;
  border-left: 1px solid rgba(255,255,255,0.45);
  border-radius: 0;
  background: transparent;
  color: #fff;
  font-size: 13px;
  line-height: 26px;
  cursor: pointer;
  white-space: nowrap;
  -webkit-appearance: none;
  appearance: none;
}
.chase-tabs button:first-child { border-left: 0; }
.chase-tabs button.on {
  background: #fff;
  color: #f42c4c;
}

.play-info {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0;
  padding: 10px 12px;
  background: #fff5f5;
  font-size: 14px;
  line-height: 1.4;
  color: #f42c4c;
  font-weight: 600;
}
.game-name,
.count-txt,
.clock {
  color: #f42c4c;
  font-weight: 600;
}

.chase-top {
  background: #f2f2f2;
}

.chase-input-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}

.chase-input-container + .chase-input-container {
  padding-top: 0;
  padding-bottom: 12px;
}

.chase-input {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.chase-input.end {
  justify-content: flex-end;
}

.chase-input.start-input {
  flex: 1;
  min-width: 0;
}

.chase-left {
  flex-shrink: 0;
  color: #333;
  font-size: 15px;
  line-height: 30px;
  white-space: nowrap;
}

.issue-arrow {
  box-sizing: border-box;
  flex: 1;
  min-width: 0;
  height: 36px;
  margin: 0;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  background: #fff;
  text-align: center;
  line-height: 34px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.add-chase-btn {
  box-sizing: border-box;
  flex-shrink: 0;
  height: 36px;
  padding: 0 16px;
  border: 0;
  border-radius: 6px;
  background: #f42c4c;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 36px;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.chase-right {
  box-sizing: border-box;
  display: inline-flex;
  align-items: stretch;
  height: 30px;
  border: 1px solid #cfcfcf;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  flex-shrink: 0;
  line-height: 1;
}

.chase-right .minus,
.chase-right .plus {
  box-sizing: border-box;
  width: 30px;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.chase-right .minus img,
.chase-right .plus img {
  width: 11px;
  height: 11px;
  display: block;
}

.chase-right .input-block {
  box-sizing: border-box;
  width: 42px;
  height: 100%;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  display: flex;
  align-items: stretch;
}

.chase-right .input-block.wide {
  width: 72px;
}

.chase-right .number-input {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: #fff;
  color: #333;
  font-size: 15px;
  line-height: 1;
  text-align: center;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.chase-right .number-input.on {
  background: #fff6c9;
}

.unit {
  flex-shrink: 0;
  color: #333;
  font-size: 15px;
  line-height: 30px;
}

.table-head {
  display: grid;
  grid-template-columns: 52px 1.2fr 0.9fr 1fr;
  align-items: center;
  height: 36px;
  padding: 0 10px;
  background: #494949;
  color: #fff;
  font-size: 13px;
}

.table-body {
  min-height: calc(100vh - 44px - 38px - 56px - 52px - 36px - 86px);
  background: #f0f1f5;
}

.chase-row {
  display: grid;
  grid-template-columns: 52px 1.2fr 0.9fr 1fr;
  align-items: center;
  min-height: 52px;
  margin: 8px 8px 0;
  padding: 0 2px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.chase-row.profit-main-row {
  margin-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.pick {
  justify-self: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1.5px solid #ccc;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pick.on {
  background: #8b5cf6;
  border-color: #8b5cf6;
}

.pick svg {
  width: 14px;
  height: 14px;
}

.issue {
  font-size: 14px;
  color: #333;
}

.mult-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.mult-box {
  box-sizing: border-box;
  min-width: 52px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 15px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
}

.mult-box.on {
  background: #fff6c9;
}

.mult-unit {
  font-size: 13px;
  color: #333;
  flex-shrink: 0;
}

.amount {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.profit-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  margin: 0 8px 0;
  padding: 8px 6px;
  border-top: 1px solid #d8d8d8;
  border-radius: 0 0 4px 4px;
  background: #fff;
}

.profit-col {
  text-align: center;
}

.profit-label {
  font-size: 14px;
  color: #60656d;
  line-height: 1.1;
}

.profit-val {
  margin-top: 2px;
  font-size: 16px;
  color: #3f4650;
  line-height: 1;
}

.ftr {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-top: 1px solid #e2e2e2;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 20;
}

.chase-keypad {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 48px);
  gap: 0;
  width: 100%;
  padding: 0;
  background: #fff;
  border-top: 1px solid #ececec;
}

.chase-keypad .key {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  justify-self: stretch;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: #fff;
  color: #333;
  font-size: 22px;
  cursor: pointer;
  box-sizing: border-box;
}

.chase-keypad .key.vk-back {
  grid-column: 3;
  grid-row: 4;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #888;
}

.chase-keypad .key.vk-back .vk-ico {
  width: 26px;
  height: 26px;
}

.chase-keypad .vk-ico {
  width: 22px;
  height: 22px;
  display: block;
}

.chase-keypad .side .vk-ico {
  width: 20px;
  height: 20px;
}

.chase-keypad .side .vk-ico.ok {
  width: 22px;
  height: 22px;
}

.chase-keypad .side {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin: 4px 6px;
  border: 0;
  border-radius: 6px;
  background: #f2f2f2;
  color: #555;
  font-size: 12px;
  cursor: pointer;
}

.chase-keypad .side.ok {
  grid-column: 4;
  grid-row: 3 / span 2;
  margin: 4px 6px 8px;
  background: #d4f6d5;
  color: #555;
  font-size: 12px;
  font-weight: 400;
}

.sum-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 34px;
  padding: 0 10px;
  font-size: 13px;
  color: #555;
}
.sum-left, .sum-right { display: flex; align-items: center; }
.hl { color: #f42c4c; font-weight: 600; }
.sum-right { gap: 4px; }
.sum-right button {
  width: 18px;
  height: 18px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.sum-right img { width: 16px; height: 16px; display: block; }

.foot-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px 8px;
}
.stop-win {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px;
  color: #555;
}
.check-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #ccc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.check-circle.on {
  background: #f42c4c;
  border-color: #f42c4c;
}
.check-circle svg { width: 14px; height: 14px; }

.bet-btn {
  flex: 1;
  height: 40px;
  border: 0;
  border-radius: 4px;
  background: #bebebe;
  color: #fff;
  font-size: 16px;
  letter-spacing: 4px;
  cursor: pointer;
}
.bet-btn:not(:disabled) { background: #f42c4c; }

.confirm-mask {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.confirm-sheet {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 12px 12px 0 0;
  padding: 16px 0 calc(env(safe-area-inset-bottom));
}

.cs-title {
  margin: 0;
  padding: 0 0 12px;
  text-align: center;
  font-size: 17px;
  line-height: 1.2;
  color: #f42c4c;
  font-weight: 500;
}

.cs-warn {
  margin: 0;
  padding: 0 20px;
  font-size: 13px;
  line-height: 1.45;
  color: #f42c4c;
  text-align: center;
  font-weight: 500;
}

.cs-warn-sub {
  margin: 2px 0 12px;
  padding: 0 20px;
  font-size: 13px;
  line-height: 1.45;
  color: #333;
  text-align: center;
}

.cs-info {
  margin: 0 16px 10px;
  padding: 12px 16px 10px;
  background: #f5f6fa;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.cs-info p { margin: 0; }

.cs-summary {
  display: flex;
  justify-content: space-between;
  padding: 6px 16px;
  margin: 0 0 4px;
  font-size: 15px;
  color: #f42c4c;
  font-weight: 600;
}

.cs-notice {
  margin: 0 0 10px;
  text-align: center;
  font-size: 13px;
  color: #f42c4c;
}

.cs-actions {
  display: flex;
  padding: 0 16px;
  gap: 12px;
}

.cs-cancel, .cs-ok {
  flex: 1;
  height: 44px;
  border: 0;
  border-radius: 22px;
  font-size: 16px;
  cursor: pointer;
}

.cs-cancel {
  background: #f5f5f5;
  color: #333;
}

.cs-ok {
  background: #f42c4c;
  color: #fff;
}

/* ===== 追号深色模式（浅色样式不动） ===== */
.page-wrap.night {
  background: #1a1a1a;
  color: #eee;
}

.page-wrap.night .play-info {
  background: #1a1a1a;
  color: #fff;
  font-weight: 500;
}

.page-wrap.night .game-name,
.page-wrap.night .clock {
  color: #f42c4c;
  font-weight: 600;
}

.page-wrap.night .count-txt {
  color: #fff;
  font-weight: 500;
}

.page-wrap.night .chase-top {
  background: #222;
}

.page-wrap.night .chase-input-container + .chase-input-container {
  border-top: 1px solid #333;
}

.page-wrap.night .chase-left,
.page-wrap.night .unit {
  color: #fff;
}

.page-wrap.night .issue-arrow {
  border-color: #666;
  background: #1a1a1a;
  color: #fff;
}

.page-wrap.night .add-chase-btn {
  background: #f42c4c;
  color: #fff;
}

.page-wrap.night .chase-right {
  border-color: #666;
  background: #1a1a1a;
}

.page-wrap.night .chase-right .minus,
.page-wrap.night .chase-right .plus {
  background: #1a1a1a;
}

.page-wrap.night .chase-right .minus img,
.page-wrap.night .chase-right .plus img {
  filter: brightness(1.6);
}

.page-wrap.night .chase-right .input-block {
  border-left-color: #555;
  border-right-color: #555;
}

.page-wrap.night .chase-right .number-input {
  background: #1a1a1a;
  color: #fff;
}

.page-wrap.night .chase-right .number-input.on {
  background: #4a4020;
  color: #ffe9a0;
}

.page-wrap.night .table-head {
  background: #333;
  color: #999;
}

.page-wrap.night .table-body {
  background: #1a1a1a;
}

.page-wrap.night .chase-row {
  background: #2a2a2a;
  box-shadow: none;
}

.page-wrap.night .pick {
  border-color: #777;
  background: transparent;
}

.page-wrap.night .pick.on {
  background: #f42c4c;
  border-color: #f42c4c;
}

.page-wrap.night .issue,
.page-wrap.night .mult-unit,
.page-wrap.night .amount {
  color: #eee;
}

.page-wrap.night .mult-box {
  border-color: #666;
  background: #1a1a1a;
  color: #fff;
}

.page-wrap.night .mult-box.on {
  background: #4a4020;
  color: #ffe9a0;
}

.page-wrap.night .profit-row {
  border-top-color: #3a3a3a;
  background: #2a2a2a;
}

.page-wrap.night .profit-label {
  color: #999;
}

.page-wrap.night .profit-val {
  color: #eee;
}

.page-wrap.night .ftr {
  background: #1a1a1a;
  border-top-color: #333;
}

.page-wrap.night .chase-keypad {
  background: #222;
  border-top-color: #333;
}

.page-wrap.night .chase-keypad .key {
  background: #2a2a2a;
  color: #eee;
  border-right: 1px solid #333;
  border-bottom: 1px solid #333;
}

.page-wrap.night .chase-keypad .key.vk-back {
  color: #aaa;
}

.page-wrap.night .chase-keypad .side {
  background: #333;
  color: #ddd;
}

.page-wrap.night .chase-keypad .side.ok {
  background: #2d4a30;
  color: #c8f0c8;
}

.page-wrap.night .sum-row {
  color: #fff;
  background: #222;
}

.page-wrap.night .hl {
  color: #f42c4c;
}

.page-wrap.night .sum-right img {
  filter: brightness(1.8);
}

.page-wrap.night .foot-row {
  background: #000;
}

.page-wrap.night .stop-win {
  color: #fff;
}

.page-wrap.night .check-circle {
  border-color: #666;
}

.page-wrap.night .check-circle.on {
  background: #f42c4c;
  border-color: #f42c4c;
}

.page-wrap.night .bet-btn {
  background: #9a9a9a;
  color: #fff;
}

.page-wrap.night .bet-btn:not(:disabled) {
  background: #f42c4c;
}

.confirm-mask.night {
  background: rgba(0, 0, 0, 0.65);
}

.confirm-mask.night .confirm-sheet {
  background: #222;
}

.confirm-mask.night .cs-title {
  color: #fff;
}

.confirm-mask.night .cs-warn {
  color: #f42c4c;
}

.confirm-mask.night .cs-warn-sub {
  color: #ddd;
}

.confirm-mask.night .cs-info {
  background: #333;
  color: #eee;
}

.confirm-mask.night .cs-summary,
.confirm-mask.night .cs-notice {
  color: #f42c4c;
}

.confirm-mask.night .cs-cancel {
  background: #3a3a3a;
  color: #fff;
}

.confirm-mask.night .cs-ok {
  background: #f42c4c;
  color: #fff;
}
</style>
